// extracted by mini-css-extract-plugin
module.exports = {"mailing":"profileInfo_mailing__3WuvY","apikey":"profileInfo_apikey__iiNxx","checkbox":"profileInfo_checkbox__2lrRv","custom__checkbox":"profileInfo_custom__checkbox__2UFrW"};